var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ideas-list"},_vm._l((_vm.ideas),function(item,index){return _c('IdeaItem',{key:item.id,attrs:{"item":item,"hide-action":true,"index":index}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }